import React, { useState } from "react";
import { Box, Link, Rating, Stack, Tab, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./MRequestDemo.scss";
import CustomButton from "../../CustomButton/CustomButton";
import RKTextField from "../../FieldTypes/RKTextField/RKTextField";
import TextArea from "../../FieldTypes/TextArea/TextArea";
import { internationalMobileNumber, isEmpty, validateEmail } from "../../../SupportingFiles/HelpingFunctions";
import { ContactForm, countryCodeOption } from "../../../Service/Type/ContactForm";
import SearchDropdown from "../../FieldTypes/SearchDropdown/SearchDropdown";

const MRequestDemo = ({ heading }: { heading?: string }) => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [formFields, setFormFields] = useState<ContactForm>({
    name: { value: "", warning: false },
    email: { value: "", warning: false },
    organization: { value: "", warning: false },
    mobile: { value: "", warning: false },
    country: { value: "", warning: false },
    message: { value: "", warning: false },
  });

  const fieldsUpdateState = (attrName: any, value: string) => {
    setFormFields({
      ...formFields, [attrName[0]]: {
        value: value, warning: isEmpty(value)
      }
    })
  };

  const resetForm = () => {
    setIsSubmitted(false);
    setFormFields({
      name: { value: "", warning: false },
      email: { value: "", warning: false },
      organization: { value: "", warning: false },
      mobile: { value: "", warning: false },
      country: { value: "", warning: false },
      message: { value: "", warning: false },
    });
  }

  const validateform = () => {
    let data = { ...formFields };
    data = {
      ...data,
      name: { ...data.name, warning: isEmpty(data.name.value) },
      email: { ...data.email, warning: !validateEmail(data.email.value) },
      organization: { ...data.organization, warning: isEmpty(data.organization.value) },
      mobile: { ...data.mobile, warning: !internationalMobileNumber(data.mobile.value, data.country.value) },
      country: { ...data.country, warning: isEmpty(data.country.value) },
      message: { ...data.message, warning: isEmpty(data.message.value) },
    }
    setFormFields({ ...data })

    let hasError = false;
    Object.values(data)?.map((item) => {
      if (item?.warning) {
        hasError = true;
      }
    })

    if (!hasError) {
      setIsSubmitted(true);
      formSubmit();
    }
  }

  const formSubmit = () => {
    setTimeout(() => {
      setIsSubmitted(false);
      resetForm(); // Reset the form
    }, 2000);
  }

  return (
    <>
      <Box className="requestDemo" marginBottom={"40px"} padding={"0px 12px"}>
        <Grid container rowSpacing={0} columnSpacing={3}>
          <Grid xs={12} textAlign={"center"}>
            {
              heading === "Get" ? <>
                <h3 className="mb-5">
                  Get in <span>Touch</span>
                </h3></>
                : <h3 className="mb-5">
                  Request a <span>Demo</span>
                </h3>
            }

            <p className="mb-5">
              Experience the Future: Request a Demo and Witness the Power of Our
              Solutions in Action!
            </p>
          </Grid>
          <Grid xs={12}>
            <Box className="img-sec" marginBottom={"24px"}>
              <img src="./images/request_demo_img.png" alt="" />
            </Box>
            <Box className="field-sec">
              <Grid container rowSpacing={0} columnSpacing={3}>
                <Grid xs={12} className="mb-5">
                  <RKTextField
                    class_name="inputField"
                    title={"Name *"}
                    value={formFields.name.value}
                    attrName={["name"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.name.warning}
                    error_messg="Please enter name"
                  />
                </Grid>
                <Grid xs={12} className="mb-5">
                  <RKTextField
                    class_name="inputField"
                    title={"Organization *"}
                    value={formFields.organization.value}
                    attrName={["organization"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.organization.warning}
                    error_messg="Please enter organization"
                  />
                </Grid>
                <Grid xs={12} className="mb-5">
                  <SearchDropdown
                    class_name="inputField"
                    title={"Country *"}
                    value={formFields.country.value}
                    attrName={["country"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.country.warning}
                    error_message="Please select country"
                    data={countryCodeOption}
                  />
                </Grid>
                <Grid xs={12} className="mb-5">
                  <RKTextField
                    class_name="inputField"
                    title={"Phone Number *"}
                    value={formFields.mobile.value}
                    attrName={["mobile"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.mobile.warning}
                    error_messg="Please enter mobile number"
                    maxLength={15}
                  />
                </Grid>
                <Grid xs={12} className="mb-5">
                  <RKTextField
                    class_name="inputField"
                    title={"Email Id *"}
                    value={formFields.email.value}
                    attrName={["email"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.email.warning}
                    error_messg="Please enter email"
                  />
                </Grid>
                <Grid xs={12} className="mb-5">
                  <TextArea
                    class_name="inputField "
                    title={"Message *"}
                    value={formFields.message.value}
                    placeholder={"Enter description here"}
                    attrName={["message"]}
                    value_update={fieldsUpdateState}
                    warn_status={formFields.message.warning}
                    error_messg="Please enter message"
                  />
                </Grid>
                <Grid xs={12} textAlign="center" className="ctaBtn">
                  {isSubmitted ? (
                    <p style={{ color: 'green' }}>
                      Thanks for submitting data. We will reach you soon
                    </p>
                  ) : (
                    <CustomButton
                      class_name="blueLgBtn"
                      text_name={"Submit Details"}
                      onClickFunction={validateform}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MRequestDemo;
